import { phonePlaceholders } from '../common/constants/phoneInputConstants';

/**
 * Get phone number placeholder by language code from i18n
 * @param {string} language - i18n.language code
 * @returns {string} phone number placeholder
 * @example
 * getPhoneNumberPlaceholder('en') // +1 (000) 000-0000
 * @see {@link phonePlaceholders} for more information
 */
export function getPhoneNumberPlaceholder(language) {
    return phonePlaceholders[language] || '+1 (000) 000-0000';
}
